
import { AbstractQueryAction, ActionData } from '../../http/data_query';
import { ColumnHelper, ConditionHelper } from './common';
import { normalizeSchemaName } from '../tools';

type SelectColumnCallback = (_: ColumnHelper) => any;

export class SelectBuilder implements AbstractQueryAction {

  constructor(
    private queryName: string
  ) { }

  private columnMap: any;

  private targetFrom: string = '';
  private targetFromAs: string = '';

  private whereRules: any;

  conditionHelpers: ConditionHelper = {
    and(conds) {
      return {$and: conds};
    },
    or(conds) {
      return {$or: conds};
    },
    eq(left, right) {
      return {$eq: [left, right]};
    },
    lt(left, right) {
      return {$lt: [left, right]};
    },
    gt(left, right) {
      return {$gt: [left, right]};
    },
    const(value) {
      return {$: value};
    },
    null(field) {
      return {$null: field};
    },
    not(field) {
      return {$not: field};
    },
    in(field, arr) {
      return {$in: [field, arr]};
    },
  };

  columnHelpers: ColumnHelper = {
    array_agg(payload) {
      return {$array_agg: payload};
    },
    obj(payload) {
      return {$obj: payload};
    }
  }

  private orderRules: any;

  private joins: any[] = [];
  fileds(columnMap: any) {
    this.columnMap = columnMap;
    return this;
  }

  fileds$(columnMap: SelectColumnCallback) {
    this.columnMap = columnMap(this.columnHelpers);
    return this;
  }

  from(nameMap: string|string[]) {
    let name, alias;

    if (Array.isArray(nameMap)) {
      name = nameMap[0];
      alias = nameMap[1];
    } else {
      name = nameMap;
      alias = nameMap;
    }

    this.targetFrom = normalizeSchemaName(name);
    this.targetFromAs = alias;

    return this;
  }

  where(conditionBuilder: (_: ConditionHelper) => any) {
    this.whereRules = conditionBuilder(this.conditionHelpers);

    return this;
  }

  order(orderBuilder: Function) {
    this.orderRules = orderBuilder({
      asc(cols: any) {
        return {$asc: cols};
      },
      desc(cols: any) {
        return {$desc: cols};
      }
    });

    return this;
  }

  leftJoin(nameMap: string|string[], conditionBuilder: Function) {
    let name, alias;

    if (Array.isArray(nameMap)) {
      name = nameMap[0];
      alias = nameMap[1];
    } else {
      name = nameMap;
      alias = nameMap;
    }

    this.joins.push({
      join: normalizeSchemaName(name),
      type: 'left',
      as:   alias,
      on: conditionBuilder(this.conditionHelpers)
    });

    return this;
  }

  innerJoin(nameMap: string|string[], conditionBuilder: Function) {
    let name, alias;

    if (Array.isArray(nameMap)) {
      name = nameMap[0];
      alias = nameMap[1];
    } else {
      name = nameMap;
      alias = nameMap;
    }

    this.joins.push({
      join: normalizeSchemaName(name),
      as:   alias,
      on: conditionBuilder(this.conditionHelpers)
    });

    return this;
  }

  private groupRules: any;
  group(fields: any[]) {
    this.groupRules = fields;

    return this;
  }

  private limitRules: any;
  limit(x: number) {
    this.limitRules = x;

    return this;
  }

  private pageRule: any;
  page(x: number) {
    this.pageRule = x;

    return this;
  }

  serialize(): ActionData {
    const query: any = {
      action: 'documents.list',
      name: this.queryName,
      params: {
        columns: this.columnMap,
        from: this.targetFrom,
        from_as: this.targetFromAs,
        joins: this.joins,
        where: this.whereRules,
        order: this.orderRules,
        ...(this.groupRules ? {groups: this.groupRules} : {}),
        ...(this.limitRules ? {page_size: this.limitRules} : {}),
        ...(this.pageRule ? {page: this.pageRule} : {})
      }
    };

    return query;
  }

}
